import {
    PUSH_FOLLOWING,
    CLEAR_PROFILE_FOLLOWING,
    UPDATE_FOLLOWING
} from "@/store/mutations.type"

const StateKey = 'profileFollowing'

export default {
    [CLEAR_PROFILE_FOLLOWING](state) {
        state[StateKey] = []
        state[`${StateKey}Offset`] = 0
        state[`${StateKey}FetchCompleted`] = false
    },

    [PUSH_FOLLOWING](state, followers) {
        if (followers.length) {
            followers.forEach((follower) => {
                if (follower) state[StateKey].push(follower)
            })
        }
        if (followers.length === state[`${StateKey}Limit`]) {
            state[`${StateKey}Offset`] += state[`${StateKey}Limit`]
        } else {
            state[`${StateKey}FetchCompleted`] = true
        }
    },

    [UPDATE_FOLLOWING](state, payload) {
        const user = state[StateKey].find(user => user.id === payload.userId)
        if(user) Object.assign(user, payload.value)
    }
}